import React from "react";

export interface ColgroupProps {
	col: number[];
}

export default function Colgroup({ col }: ColgroupProps) {
	return (
		<colgroup>
			{col.map((width, index) => {
				return <col width={`${width}%`} key={index} />;
			})}
		</colgroup>
	);
}
